import React from 'react';
import styled from 'styled-components';
import DateHelpers from '../../../../../core/helpers/DateHelper';
import iconCalendarDot from '../../../../../assets/icons/icon-calendar-dot.svg';
import IDHelpers from '../../../../../core/helpers/IDHelper';

const DayContainer = styled.div.attrs((props: any) => ({
  isCard: props.isCard,
  isDetail: props.isDetail
}))`
  gap: ${(props) => (props.isCard ? 4 : 8)}px;
  flex-wrap: wrap;
  display: flex;
  ${(props) => (props.isDetail ? '' : 'margin-bottom:0px;')}
  & img {
    // margin-right: 8px;
  }
  & span {
    border-radius: 24px;
    border: 1px solid #161d1f;
    color: #161d1f;
    font-size: 12px;
    line-height: 16px;
    padding: 4px 8px;
    height: 24px;
    display: flex;
    align-items: center;
  }
`;

interface Schedule {
  idDay: number;
  startTime: string;
  endTime: string;
  // date: number;
}
interface EventScheduleDaysProps {
  isCard?: boolean;
  isOnly: boolean;
  schedule: Schedule[];
}
export const isSameTime = (schedule: Schedule[]) => {
  const search = schedule.reduce((acc: any, sch) => {
    const key = JSON.stringify({ start: sch.startTime, end: sch.endTime });
    // eslint-disable-next-line no-plusplus
    acc[key] = ++acc[key] || 0;
    return acc;
  }, {});
  return Object.keys(search).length === 1;
};

export const numberOfDays = (schedule: Schedule[]) => schedule.length;

const EventScheduleDays: React.FC<EventScheduleDaysProps> = ({
  isCard,
  isOnly,
  schedule
}) => {
  const uniqueDays = () => Array.from(new Set(schedule.map((sh) => sh.idDay)));
  const g = uniqueDays().sort((a, b) => a - b);

  if (isOnly || (!isSameTime(schedule) && !isCard)) return null;
  return (
    <>
      {g.length <= 5 && (
        <DayContainer data-testid="cmp-event-schedule-day" isCard={isCard}>
          {!isCard && <img src={iconCalendarDot} alt="" />}
          {g.map((item) => (
            <span key={IDHelpers.generateID()}>
              {DateHelpers.getDayNameOfWeek(item)}
            </span>
          ))}
        </DayContainer>
      )}
    </>
  );
};

EventScheduleDays.defaultProps = {
  isCard: false
};

export default EventScheduleDays;
